import { useResponsiveTier } from 'pi-kiosk-shared/responsive';

/**
 * L32 Pattern A — feature screens unmount the inactive table/card tree via this
 * boolean. Shell chrome continues to call `useResponsiveTier()` directly.
 */
export function useIsCompactTier(): boolean {
  return useResponsiveTier() === 'compact';
}
